import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-completed-commission-report',
  templateUrl: './completed-commission-report.component.html',
  styleUrl: './completed-commission-report.component.scss'
})
export class CompletedCommissionReportComponent {

constructor(
    private dialogRef: MatDialogRef<CompletedCommissionReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
  ) {
  }


today: Date = new Date();

  startDate: any = '';
  endDate: any = '';
  repName = '';
  offRepName = '';
  advtName = '';
  reportType = '';
  issueDates: any;
  issueDates1: any;
  getpaiddata: any;
  paidcommTotal: number;
  comtotal: number;
  issue_name :any;

  

 ngOnInit(): void {

debugger
let repname: any = this.data['repName'];

    // Then check if it's not empty and convert to array
    if (repname != "") {
      repname = [repname]; // This puts the single value in an array
    }

    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'];
    this.issueDates = this.data.issue_date;
    this.issueDates1 = this.data['issue_date'];
    this.issue_name = this.data['issue_name'];

  // const req: any = {
  //  "rep_name":  this.repName,
  //   "start_date": this.startDate,
  //   "end_date": this.endDate,
  //   "off_rep_name": this.offRepName,
  //   "advt_name": this.data['name'],
  //   // // "issue_name" : this.advtName,
  //   // "issue_date": this.issueDates
  //   "issue_name": "",
  //   "issue_date": this.issueDates1


  // }

  const req: any = {
    "rep_name": repname,
    "start_date": this.startDate,
    "end_date": this.endDate,
    "off_rep_name": this.offRepName,
    "advt_name": this.data['name'],
    // // "issue_name" : this.advtName,
    // "issue_date": this.issueDates
    "issue_name": this.issue_name,
    "issue_date": this.issueDates

  }

// Paid Commission 
    this.service.getPaidCommData(req).subscribe((data: any) => {
      debugger
      console.log("Get Paid Comm", data)
      this.getpaiddata = data as any;

      this.paidcommTotal = 0;
      this.comtotal = 0;
      for (let data1 of this.getpaiddata) {
        for (let data2 of data1.rep_data) {
          this.paidcommTotal += parseInt(data2.rcv_amt) || 0;
          this.comtotal += parseInt(data2.com_amt) || 0;
        }
      }

    });

 
  }

  

}
